{
  "version": 1,
  "asset_id": "a6785c87-b25c-4824-af80-826d643f5522",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/a6785c87-b25c-4824-af80-826d643f5522/ind-ecommerce-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/a6785c87-b25c-4824-af80-826d643f5522/ind-ecommerce-640.webp",
  "original_filename": "ind-ecommerce-640.webp",
  "size": 7726,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:01Z"
}
